import { Component, computed, signal } from '@angular/core'

import { FormsModule } from '@angular/forms'
import { EntityRef } from 'src/app/shared/models/referenceData'
import { DateRangeFilterStateValue } from 'src/app/shared/services/filter/date-range-filter'
import { DateRangeFilterPickerComponent } from '../date-range-filter-picker/date-range-filter-picker.component'
import { LabeledPropertyComponent } from '../labeled-property/labeled-property.component'
import { ModalBodyComponent } from '../modals/modal-body/modal-body.component'
import { ModalFooterComponent } from '../modals/modal-footer/modal-footer.component'
import { ModalHeaderComponent } from '../modals/modal-header/modal-header.component'
import { NumberInputComponent } from '../number-input/number-input.component'
import { TBillSchedule1RateCreateRequest } from '../settlements/tbill-settlements.types'

interface ModalState {
  month: DateRangeFilterStateValue, rate: number
}

@Component({
  imports: [
    FormsModule,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    LabeledPropertyComponent,
    DateRangeFilterPickerComponent,
    NumberInputComponent,
  ],
  selector: 'app-create-tbill-schedule-1-rate-modal',
  styles: '',
  template: `
    <div app-modal-header>Create Schedule 1 Rate</div>

    <div app-modal-body>
        <div app-labeled-property label="Month">
            <div dateRangeFilterPicker
            [value]="modalState().month"
            (valueChange)="updateMonth($event)"
            [showOperation]="false"
            [showRange]="false"
            [showTime]="false"
            [showSeconds]="false"
            [onlyMonth]="true"
            ></div>
        </div>
        <div app-labeled-property label="Rate ($/(MW\u00A0MTH))">
            <div app-number-input
            [value]="modalState().rate ?? 0"
            (valueChange)="updateRate($event)"
            ></div>
        </div>
    </div>

    <div app-modal-footer>
        <button
        class="action-btn primary"
        [disabled]="!canCreate()"
        (click)="create()"
        >
        Create
        </button>
        <button class="action-btn" (click)="onCancel()()">Cancel</button>
    </div>
    `,
})
export class CreateTBillSchedule1RateModalComponent {
  protected readonly modalState = signal<Partial<ModalState>>({})
  protected readonly onCreate = signal<(req: TBillSchedule1RateCreateRequest) => void>(() => void 0)
  protected readonly onCancel = signal<() => void>(() => void 0)

  canCreate = computed(() => {
    const state = this.modalState()
    return state.month &&
      !Number.isNaN(state.rate) &&
      state.rate != undefined
  })

  init(overrides: Partial<{
    modalState: Partial<ModalState>,
    onCreate: (req: TBillSchedule1RateCreateRequest) => void,
    onCancel: () => void
  }>) {
    this.modalState.update(v => ({ ...v, ...(overrides.modalState ?? {}) }))
    this.onCreate.update(v => overrides.onCreate ?? v)
    this.onCancel.update(v => overrides.onCancel ?? v)
  }

  updateMonth(month: DateRangeFilterStateValue) {
    this.modalState.update(v => ({ ...v, month }))
  }
  updateControlArea(control_area: EntityRef) {
    this.modalState.update(v => ({ ...v, control_area }))
  }
  updateRate(rate: number) {
    this.modalState.update(v => ({ ...v, rate }))
  }
  create() {
    this.onCreate()({
      month: this.modalState().month!.value as Date,
      rate: this.modalState().rate!,
    })
  }
}
